import WithClickOutside from './WithClickOutside';

export default WithClickOutside;
